import { render } from "./FacturaServiciosList.vue?vue&type=template&id=f78ce886&scoped=true"
import script from "./FacturaServiciosList.vue?vue&type=script&lang=js"
export * from "./FacturaServiciosList.vue?vue&type=script&lang=js"

import "./FacturaServiciosList.vue?vue&type=style&index=0&id=f78ce886&scoped=true&lang=css"

import exportComponent from "/home/runner/work/jeanInformatico-management-system/jeanInformatico-management-system/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f78ce886"]])

export default __exports__